import { useState, useEffect } from "react";
import api from "../services/api";
import Sidebar from "../components/Sidebar";
import { FaClock, FaTrash } from "react-icons/fa";

export default function Horarios(){

  const [turmas, setTurmas] = useState([]);
  const [professores, setProfessores] = useState([]);
  const [horarios, setHorarios] = useState([]);

  const [form, setForm] = useState({
    turma_id: "",
    professor_id: "",
    dia_semana: "",
    hora_inicio: "",
    hora_fim: ""
  });

  // Carregar turmas, professores e horários
  useEffect(()=>{
    loadTurmas();
    loadProfessores();
    loadHorarios();
  },[]);

  const loadTurmas = async () => {
    const res = await api.get("/turmas");
    setTurmas(res.data);
  };

  const loadProfessores = async () => {
    const res = await api.get("/professores");
    setProfessores(res.data);
  };

  const loadHorarios = async () => {
    const res = await api.get("/horarios");
    setHorarios(res.data);
  };

  // Salvar horário
  const salvar = async e => {
    e.preventDefault();

    if(!form.turma_id || !form.professor_id || !form.dia_semana || !form.hora_inicio || !form.hora_fim){
      alert("Preencha todos os campos!");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      await api.post("/horarios", {
        turma_id: Number(form.turma_id),
        professor_id: Number(form.professor_id),
        dia_semana: form.dia_semana,
        hora_inicio: form.hora_inicio,
        hora_fim: form.hora_fim
      }, {
        headers: { Authorization: token }
      });

      setForm({ turma_id:"", professor_id:"", dia_semana:"", hora_inicio:"", hora_fim:"" });
      loadHorarios();
    } catch (err) {
      console.log(err.response?.data || err);
    }
  };

  // Remover horário
  const remover = async id => {
    try {
      const token = localStorage.getItem("token");
      await api.delete(`/horarios/${id}`, {
        headers: { Authorization: token }
      });
      loadHorarios();
    } catch (err) {
      console.log(err.response?.data || err);
    }
  };

  return (
    <Sidebar>
      <div className="horarios-container">

        <h2><FaClock /> Gestão de Horários</h2>

        {/* FORM */}
        <form className="horarios-form" onSubmit={salvar}>

          <select
            value={form.turma_id}
            onChange={e=>setForm({...form, turma_id:e.target.value})}
            required
          >
            <option value="">Selecione Turma</option>
            {turmas.map(t => (
              <option key={t.id} value={t.id}>{t.nome} - {t.nivel}</option>
            ))}
          </select>

          <select
            value={form.professor_id}
            onChange={e=>setForm({...form, professor_id:e.target.value})}
            required
          >
            <option value="">Selecione Professor</option>
            {professores.map(p => (
              <option key={p.id} value={p.id}>{p.nome} - {p.especialidade}</option>
            ))}
          </select>

          <select
            value={form.dia_semana}
            onChange={e=>setForm({...form, dia_semana:e.target.value})}
            required
          >
            <option value="">Dia da Semana</option>
            <option value="SEG">Segunda</option>
            <option value="TER">Terça</option>
            <option value="QUA">Quarta</option>
            <option value="QUI">Quinta</option>
            <option value="SEX">Sexta</option>
            <option value="SAB">Sábado</option>
          </select>

          <input
            type="time"
            value={form.hora_inicio}
            onChange={e=>setForm({...form, hora_inicio:e.target.value})}
            required
          />

          <input
            type="time"
            value={form.hora_fim}
            onChange={e=>setForm({...form, hora_fim:e.target.value})}
            required
          />

          <button>Salvar</button>
        </form>

        {/* TABELA */}
        <table className="horarios-table">
          <thead>
            <tr>
              <th>Turma</th>
              <th>Professor</th>
              <th>Dia</th>
              <th>Hora</th>
              <th>Período</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {horarios.map(h => (
              <tr key={h.id}>
                <td>{h.turma_nome}</td>
                <td>{h.professor_nome}</td>
                <td>{h.dia_semana}</td>
                <td>{h.hora_inicio} - {h.hora_fim}</td>
                <td>
                  <span className={h.periodo==="MANHA" ? "manha" : "tarde"}>
                    {h.periodo}
                  </span>
                </td>
                <td>
                  <button onClick={()=>remover(h.id)} className="delete-btn"><FaTrash/></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </Sidebar>
  );
}
